import { LoginForm } from 'components/LoginForm/LoginForm';

export const UnAuthenfiedView: React.FC = () => {
    return <LoginForm />;
};
